import { render } from "./CloneVpcOffering.vue?vue&type=template&id=b5f0d424&scoped=true"
import script from "./CloneVpcOffering.vue?vue&type=script&lang=js"
export * from "./CloneVpcOffering.vue?vue&type=script&lang=js"

import "./CloneVpcOffering.vue?vue&type=style&index=0&id=b5f0d424&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f0d424"]])

export default __exports__